import React from "react";
import { Badge, Avatar } from "@heroui/react";
import { AvatarOption } from "../Emojis";

type Props = {
  children?: React.ReactNode;
  isOnline: boolean;
  name: string;
  avatarUUID?: string;
};

const User: React.FC<Props> = (props) => {
  const avatar = new AvatarOption(props.avatarUUID);

  return (
    <div className="flex gap-2 items-center">
      <Badge content="" color={props.isOnline ? "success" : "danger"} shape="circle" placement="bottom-right">
        <Avatar src={avatar.getUrl()} />
      </Badge>
      <p className="hidden xl:block">{props.name}</p>
    </div>
  );
};

export default User;
